import React from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";

function NewUpdatePopup({setIsAppUpdatePopupShow,unloadAppversionPopup,...props}) {
  const newUpdateStyle = {
    display: "flex",
    zIndex: "9999999",
    position: "absolute",
    background: "#6a2bf3",
    color: "#fff",
    flexFlow: "row",
    justifyContent: "center",
    margin: "auto",
    width: "100%",
    maxWidth: "317px",
    left: "0px",
    right: "0px",
    top: "0px",
    padding: "10px",
    alignItems: "center",
    gap: 25
  }
  const studioRefreshHandler = () => {
    localStorage.setItem("app-refresh-trigger", "true");
    unloadAppversionPopup?.();
  }
  return (
    <div style={newUpdateStyle}>
        <div
            style={{fontSize: 16}}
        >Refresh to get latest Studio version</div>
        <Button variant="warning" onClick={studioRefreshHandler}>Refresh</Button>
    </div>
  )
}

export default NewUpdatePopup